export const LESSEE_SYSTEM_NOTIFICATION_CATEGORY = {
  INCIDENT: "障害対応",
  MAINTENANCE: "メンテナンス情報",
  UPDATE: "アップデート情報",
} as const;

export type LesseeSystemNotificationCategory =
  typeof LESSEE_SYSTEM_NOTIFICATION_CATEGORY[keyof typeof LESSEE_SYSTEM_NOTIFICATION_CATEGORY];

export const LESSEE_SYSTEM_NOTIFICATION_CATEGORY_CHOICES = Object.values(LESSEE_SYSTEM_NOTIFICATION_CATEGORY);

// 配列をjoinしてあげて見やすく宣言
export const SYSTEM_NOTIFICATION_PLACEHOLDER = [
  "平素は、at PORTをご利用いただき、誠にありがとうございます。システムトラブル発生のため、各種申請の受付を一時停止しております。",
  "復旧が確認できましたら、改めてご連絡差し上げます。ご迷惑をおかけいたしますが、ご理解いただきますようお願いいたします。",
].join("\n");
